import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { encrypt } from "../Utils/Encryption";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";

const GaugeCompare = ({ metricData }) => {
  const coordinates_data = JSON.parse(
    metricData?.comparison_coordinates || "{}"
  );
  const currentData = metricData?.value?.[0] || {};

  const [chartData] = useState({
    series: [Number(currentData?.metric_1) || 0],
    options: {
      chart: {
        type: "radialBar",
        offsetY: -20,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 135,
          hollow: {
            margin: 0,
            size: "70%",
            background: "#fff",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: "#f0f0f0",
            strokeWidth: "67%",
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },
          dataLabels: {
            show: true,
            name: {
              offsetY: -10,
              show: true,
              color: "#888",
              fontSize: "17px",
            },
            value: {
              formatter: (val) => parseInt(val),
              color: "#111",
              fontSize: "36px",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.4,
          gradientToColors: ["#3a80c2"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
        colors: ["#3a80c2"],
      },
      labels: [
        coordinates_data?.visualization_data?.datasets?.[0]?.label || "Metric",
      ],
    },
  });

  return (
    <div className="col-12 h-100 ChartData">
      <div className="dashboardCharttitleContainer">
        {metricData?.child && metricData?.pk_comparison_data_id ? (
          <Link
            to={`/dashboard/comparisonchildmetric/${
              metricData?.comparison_name
            }/${encrypt(metricData?.pk_comparison_data_id?.toString())}`}
            className="dashboardCharttitle dashboardCharttitleActive"
          >
            <span className="text-md">{metricData?.comparison_name}</span>
            <GoLinkExternal className="externelLink" />
          </Link>
        ) : (
          <div className="dashboardCharttitle">
            <span className="text-md">{metricData?.comparison_name}</span>
          </div>
        )}
      </div>

      <div className="dashboardChart col-12 d-flex justify-content-center">
        <ReactApexChart
          options={chartData?.options}
          series={chartData?.series}
          type="radialBar"
          width="350"
          height="350"
        />
      </div>
    </div>
  );
};

export default GaugeCompare;
